import React from 'react';
import { LogOut } from 'lucide-react';
import { Button } from '../ui/button';
import { useTranslation } from 'react-i18next';

interface AuthSectionProps {
  session: any;
  handleGoogleLogin: () => void;
  handleLogout: () => void;
}

const AuthSection: React.FC<AuthSectionProps> = ({ session, handleGoogleLogin, handleLogout }) => {
  const { t } = useTranslation();

  return (
    <div className="card mb-6">
      <h4 className="font-medium text-gray-800 mb-4">{t('profile.auth.title')}</h4>
      <p className="text-sm text-gray-600 mb-4">
        {t('profile.auth.description')}
      </p>
      
      {!session ? (
        <Button
          onClick={handleGoogleLogin}
          className="w-full bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
          variant="outline"
        >
          <img 
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
            alt="Google Logo" 
            className="w-5 h-5 mr-2"
          />
          {t('profile.auth.signInWithGoogle')}
        </Button>
      ) : (
        <div className="text-center">
          <p className="text-sm text-green-600 mb-2">
            {t('profile.auth.signedInAs')} {session.user?.email}
          </p>
          <Button 
            onClick={handleLogout} 
            variant="outline"
            className="text-red-500 border-red-200 hover:bg-red-50 hover:text-red-600"
          >
            <LogOut className="w-4 h-4 mr-2" />
            {t('profile.auth.signOut')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default AuthSection;
